<custom-link [isRemote]="false" 
             [url]="downloadLinkUrl" 
             [title]="codeValue.title" 
             [icon]="codeValue.icon" 
             [defaultIcon]="'code'"
             [extraStyles]="'py-2'"
             [imageSet]="imageSet"></custom-link>